import { render, staticRenderFns } from "./_Deliveries.vue?vue&type=template&id=c0c3ebb2&"
import script from "./_Deliveries.vue?vue&type=script&lang=js&"
export * from "./_Deliveries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports